import { createPortal } from 'react-dom'

import { cn } from '@/utils/tailwind'

export type ToastPhase = 'in' | 'out' | 'hidden'

interface ToastProps {
  message: string
  phase: ToastPhase
}

export const Toast = ({ message, phase }: ToastProps) => {
  if (phase === 'hidden') return null

  return createPortal(
    <div
      role="status"
      aria-live="polite"
      className={cn(
        'pointer-events-none fixed top-[54px] left-1/2 z-50 -translate-x-1/2 -translate-y-1/2 rounded-full bg-white px-4 py-2 text-sm whitespace-nowrap shadow-md',
        phase === 'in' && 'animate-fade-in',
        phase === 'out' && 'animate-fade-out'
      )}
    >
      {message}
    </div>,
    document.body
  )
}
